export default {
  title: {
    en: 'Oops! <br />Our Birdie is updating the site',
  },
  subTitle: {
    en: 'Please reload the page in a few minutes',
  },
}
